/** Arabic where the same English means different things; keys are "English@context" (see tc() in i18n/index.tsx). Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "Operations@access": "تشغيلي",
  "Engineering@access": "هندسي",
  "Executive@access": "تنفيذي",
  "Master@access": "كامل",
  "Met@weather": "الأرصاد الجوية",
  "Target@map": "الهدف",
};
export default ar;
